export const panelTypes = {
  FULL_SIZE: 'full_size',
  HALF_SIZE: 'half_size',
}

export const GROUP_CLASS_NAME = 'group'
